import { StopIcon } from '@heroicons/react/24/outline';
import { SVGProps } from 'react';

export function ExpandIcon({
  className = '',
  'aria-hidden': ariaHidden = true,
  ...props
}: SVGProps<SVGSVGElement>) {
  return <StopIcon className={className} aria-hidden={ariaHidden} {...props} />;
}
